import React from 'react';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { actions as authenticationActions } from '../../../actions/authentication'
import { actions as employeeActions } from '../../../actions/employee'
import { actions as staticContentActions } from '../../../actions/static_content'
import { actions as configurationActions } from '../../../actions/configuration'
import GenericModal from '../../../components/GenericModal'
import ErrorImage from '../../../images/error.png'
import { history } from '../../../store'

const Content = styled.div`

  padding: 15px 20px 20px 20px;

  > div.error {
    border: 1px solid #DB3766;
    background-image: url(${ErrorImage});
    background-repeat: no-repeat;
    background-position-x: 10px;
    background-position-y: center;
    font-family: Lato-Regular;
    font-size: 14px;
    padding: 15px 15px 15px 40px;
    margin-bottom: 15px;
  }

  > p {
    font-family: Lato-Regular;
    font-size: 14px;
    line-height: 22px;
    color: #2B2B2B;
    margin: 0px;
    margin-bottom: 0px;
  }

  > label {
    display: block;
    font-family: Lato-Regular;
    font-size: 12px;
    font-weight: normal;
    line-height: 16px;
    color: #666666;
    margin-top: 10px;
    margin-bottom: 7px;
  }

  > input {
    width: 100%;
    box-sizing: border-box;
  }
`

const Footer = styled.div`
  > button {
    height: 43px;
    width: calc(50% - 10px);
  }

  > button.cancel-impersonate-user {
    margin-right: 10px;
  }

  > button.confirm-impersonate-user {
    margin-left: 10px;
  }
`

class ImpersonateUserDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: true,
      employeeId: '',
      error: false
    };
  }

  yesButtonClickHandler = () => {
    this.props.actions.authentication.impersonateEmployee(this.state.employeeId, () => {
      this.props.actions.employee.unload()
      this.props.actions.configuration.unload()
      this.props.actions.static_content.unload()
      history.push('/dashboard')
    }, () => {
      this.setState(
        {error: true}
      )
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && (this.props.visible !== prevProps.visible)) {
      this.onOpenDialog()
    }
  }

  onOpenDialog = () => {
    this.props.actions.authentication.clearAuthenticationError()
  }

  setEmployeeId = (e) => {
    this.setState(
      {employeeId: e.target.value}
    )

    if (e.target.value != e.target.previousValue){
      this.setState(
        {error: false}
      )
    }
  }
  render() {
    const { t } = this.props;

    return (
      <GenericModal
        title={t('ImpersonateUserDialog.HeaderLabel')}
        hideCloseButton={this.props.hideCloseButton}
        visible={this.props.visible}
        onCloseDialog={this.props.onCloseDialog}
        width={380}
        className="impersonate-user-modal"
      >
        <Content>
          {this.state.error &&
            <div role='alert' className={"error"}>{t("ImpersonateUserDialog.ErrorMessage")}</div>
          }

          <p>{t('ImpersonateUserDialog.PleaseEnterLabel')}</p>
          <label htmlFor="employee_id">{t('ImpersonateUserDialog.EmployeeIdLabel')}</label>
          <input name="employee_id" id="employee_id" className={this.state.error ? "custom-textfield error" : "custom-textfield"} type="text" onChange={this.setEmployeeId} />
        </Content>
        <Footer>
          {!this.props.hideCloseButton &&
            <button className="cancel-impersonate-user secondary-button" onClick={this.props.onCloseDialog}>{t('ImpersonateUserDialog.CancelButton')}</button>
          }
          <button className="confirm-impersonate-user primary-button" style={this.props.hideCloseButton ? {'width': '100%', 'margin-left': 0} : {}} onClick={this.yesButtonClickHandler}>{t('ImpersonateUserDialog.YesButton')}</button>
        </Footer>
      </GenericModal>
    );
  }
}

const mapState = state => ({
  employee: state.employee,
  configuration: state.configuration,
  auth: state.auth
})

const mapDispatchToProps = dispatch => ({
  actions: {
    authentication: bindActionCreators(authenticationActions, dispatch),
    employee: bindActionCreators(employeeActions, dispatch),
    static_content: bindActionCreators(staticContentActions, dispatch),
    configuration: bindActionCreators(configurationActions, dispatch),
  }
})

export default connect(mapState, mapDispatchToProps)((withTranslation('translations')(ImpersonateUserDialog)))
